var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.computedAs,_vm._g({tag:"component",attrs:{"id":_vm.id,"is-open":_vm.isOpen}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }